import React, { useState, createContext, useEffect } from 'react';

const Context = createContext(undefined);

const ConTextProvider = ({ children }) => {
    return (
        <Context.Provider value={{}}>
            {children}
        </Context.Provider>
    );
};
export { ConTextProvider, Context };